<template>
	<div class="trigger-form-container flex-centerize flex-wrap">
		<div class="form-item col-12" v-for="(formItem, i) in formItems" :key="i">
			<component :is="formItem.component" v-on="formItem.listeners" v-bind="formItem.props" />
		</div>
	</div>
</template>

<script>
export default {
	name: 'TriggerForm',
	props: { formItems: { type: Array } },
};
</script>

<style lang="scss" scoped>
.trigger-form-container {
	width: var(--base-width);
}
</style>
